import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AntifraudWarningComponent } from './antifraud-warning.component';
import { AntifraudWarningService } from './antifraud-warning.service';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
    declarations: [AntifraudWarningComponent],
    imports: [	CommonModule , SharedModule ],
    exports: [AntifraudWarningComponent],
    providers: [AntifraudWarningService]
})
export class AntifraudWarningModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/antifraud-warning/antifraud-warning.module.ts